export default "/images/stop-circle.svg?071bf69e2f4eea9a7e2548ef1088b28f";